<template>
  <div :id="'comment-' + id" class="comment">
    <section class="box" >

      <div>
        <div class="content">
        <div class="user-container">
          <section class="comment-header mb-1">

            <a class="video-title" :href="'/videos/' + videoID">From Video: {{ videoTitle }}</a>

            <section class="timestamp-section">

              <a class="tag is-primary play-tag no-select" :href="'/videos/' + videoID">
              <PlayIcon />

              {{ prettyTimeStamp(start_time, end_time) }}</a>
            </section>
            <section class="user-name-container mt-1">
              <section class="user-name-section">
                <img :src="user.avatar_url" class="image is-32x32 mr-1 rounded">
                <strong>{{ user.name || user.email }}</strong>
              </section>

              <UpdatingTime :time="created_on" class="text-muted"/>
            </section>
            <div class="time-picker-container" v-if="editing">
              <span class="my-input-container">
                <input
                  v-model="startTimeMins"
                  placeholder="01"
                  type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
              </span>
              <span class="my-time-divider">:</span>
              <span class="my-input-container">
                <input
                  v-model="startTimeSecs"
                  placeholder="21"
                  type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
              </span>

              <div class="time-divider"></div>

              <span class="my-input-container">
                <input
                  v-model="endTimeMins"
                  placeholder="09"
                  type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
              </span>
              <span class="my-time-divider">:</span>
              <span class="my-input-container">
               <input
                v-model="endTimeSecs"
                placeholder="57"
                type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
              </span>
            </div>

          </section>
        </div>
          <p v-if="!editing" class="white-space-pre">{{ body }}</p>
          <textarea
            @keydown.esc="editing = false"
            @keydown.shift.enter="updateComment()"
            v-if="editing"
            v-textautosize
            v-select
            class="textarea"
            placeholder="Add a comment..."
            ref="body"
            :value="body"/>


          <section class="tags">
            <Tag v-for="tag in tags"
              :key='tag.id'
              :id='tag.id'
              :rubric='tag.rubric'
              :color='tag.color'
              :title='tag.title'
              :videoID='videoID'
              :commentID='id'
              :editing='editing'
              :score="getScore(tag.id)"
            />
            
          </section>
        </div>

        <div class="reply-container">
          <Reply v-for="reply in replies"
            :key = 'reply.id'
            :id = 'reply.id'
            :body = 'reply.body'
            :cycleID = 'cycleID'
            :videoID = 'videoID'
            :commentID = 'id'
            :editable = 'false'
            :name = 'reply.user.name || reply.user.email'
            :avatar_url = 'reply.user.avatar_url'
            :created_on = 'reply.created_on'
          />
        </div>

      </div>
    </section>

  </div>
</template>

<script>
import Reply from './Reply.vue'
import PlayIcon from './PlayIcon.vue'

import Tag from './Tag.vue'

import UpdatingTime from './UpdatingTime.vue'

import { prettyTimeStamp, prettyDate } from '../filters.js'

import { textautosize, select } from '../directives.js'

export default {
  name: 'ReadOnlyComment',
  props: {
    elements: {
      type: Array,
      required: false,
    },
    cycleID: {
      type: Number,
      required: false,
    },
    videoID: {
      type: Number,
      required: true,
    },
    videoTitle: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    replies: {
      type: Array,
      required: true,
    },
    replies_editing: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
    body: {
      type: String,
      required: true,
    },
    created_on: {
      type: String,
      required: true,
    },
    start_time: {
      required: true,
    },
    end_time: {
      required: true,
    },
    userID: {
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
    scores: {
      type: Array,
      required: true,
    },
  },
  components: {
    Reply,
    PlayIcon,
    Tag,
    UpdatingTime,
  },
  filters: {
    prettyDate,
  },
  directives: {
    textautosize,
    select,
  },
  data () {
    return {
      editing: false,
      showAddRubricTagModal: false,
      showAddTagModal: false,
      endTimeMins: '',
      endTimeSecs: '',
      startTimeMins: '',
      startTimeSecs: '',
      replyText: '',
      deleting: false,
      updating: false,
    }
  },
  computed: {
  },
  methods: {
    prettyTimeStamp,
    getScore (tagID) {
      for (const score of this.scores) {
        if (score.tag === tagID) {
          return score.value
        }
      }
      return null
    },
  },
}
</script>

<style lang="scss" scoped>
// setup the outline of the comment so when a user clicks the play button, it
// is selected
@import '../_variables.scss';

.video-title {
  font-size: 1.2rem;
  margin-bottom: 15px;
  font-weight: bold;
}

.comment {
  margin: 3px;
  border-radius: 45px;

  outline-color: transparent;
  transition: outline-color 0.2s;
}

.box {
  border-radius: 15px;
}

.user-name-section {
  display: flex;
  align-items: center;
}

.play-tag {
  font-size: 1rem;
}

.user-name-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

.editting-comments-container > a {
  margin-left: 1.5rem;
}

.time-picker-container {
  display: flex;
  align-items: center;
  margin-bottom: .75rem;
}

.comment-header {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.timestamp-section {
  display: flex;
  align-items: center;
  justify-content: center;
}

.reply-buttons {
  margin-top: .75rem;
  margin-bottom: .75rem;
}

// Bulma override so comments aren't space weird
.content:not(:last-child) {
  margin-bottom: 0;
}

.content p:not(:last-child) {
  margin-bottom: 0.25rem;
}

.time-divider {
  width: 1rem;
  height: 3px;
  border-radius: $radius-large;
  background-color: gray;
  margin: 5px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reply-container {
  margin-left: 10px;
  border-left: 3px #dbdbdb solid;
  padding-left: 5px;
}


.reply-user-name-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
}



.my-input {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  box-shadow: none;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
}

.tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}


@import '../_variables.scss';

.button.rubric-tag {
  background-color: rgb(229, 0, 233);
  border-radius: 3px;
  color: whitesmoke;
  font-weight: bold;
  text-shadow: $nice-gray 1px 1px 6px;
  margin-top: .75rem;
  margin-bottom: .75rem;
}


.reply-container {
  margin-left: 10px;
  border-left: 3px #dbdbdb solid;
  padding-left: 5px;
}

// added to a new comment
.new {
  animation: new 1.5s;
  outline-style: solid;

  @keyframes new {
    0% {
      opacity: 1;
      outline-color: transparent;
    }
    50% {
      opacity: 0.5;
      outline-color: $teal;
    }
    100% {
      opacity: 1;
      outline-color: transparent;
    }
  }
}

.no-select {
  user-select: none;
}

.white-space-pre {
  white-space: pre-wrap;
}

</style>



// WEBPACK FOOTER //
// ReadOnlyComment.vue?e923ec24